<template>
  <div class="exhibition">
    <!-- <HeaderTop></HeaderTop> -->
    <!-- <Header :page="3"></Header> -->
    <div class="banner flex-align-center">
      <img src="../../assets/header/wx.png" alt="" />
    </div>
    <div class="service-box main">
     <div class="common">
        <div class="common-top flex-column-center">
          <p>北京市中小学书画作品巡展活动</p>
          <p style="width:100%;" class=" flex-align-center"><span></span></p>
        </div>
        <div class="column">
            <!-- <div class="column-top">
                <div class="summary flex-align">
                    <span>展览介绍</span>
                    <span>展览作品</span>
                    <span>留言留言</span>
                </div>
            </div>
            <div class="column-center  flex-align-around">
                <p class="flex-align-center">  <img src="../../assets/home/shijian.png" alt="">时间：2021.09.21-2021.09.30</p>
                <p class="flex-align-center">  <img style="width: 23px;height: 25px;" src="../../assets/home/didian.png" alt="">地点：北京六一学校学生活动中心</p>
            </div> -->
            <div class="column-bottom">
                <p>CCPT书画等级考试历年优秀作品巡展活动是由首都师范大学、首都师范大学出版社主办，首师科技教育培训中心承办，北京乐智启航文化发展有限公司协办，邀请组考单位、优秀学生家长、各大媒体等参与巡展，展示交流优秀获奖作品，推广北京地区书画等级考试，为组考单位赋能。</p>
            </div>
        </div>
      </div>
      <div class="common">
        <div class="common-top flex-column-center">
          <p>展览作品</p>
          <p class="flex-align-center"><span></span></p>
        </div>
          <div class="img-list flex-align-wrap">
               <div class="series-item" v-for="(item,index) in TeachingList" :key="index" >
                 <div class="item-board">
                   <img :src="item.cover" alt="">
                   <p>{{item.name}}</p>
                 </div>
               </div>
             </div>
      </div>



    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
        TeachingList:[
          {
            name:'郑涵睿  11岁',
            cover:require(`@/assets/dengkao/1.jpg`)
          },
          {
            name:'梁家明 10岁',
            cover:require(`@/assets/dengkao/2.jpg`)
          },{
            name:'安楚凝 14岁',
            cover:require(`@/assets/dengkao/3.jpg`)
          },{
            name:'王墨妍 12岁',
            cover:require(`@/assets/dengkao/4.jpg`)
          },{
            name:'贺欣怡 8岁',
            cover:require(`@/assets/dengkao/5.jpg`)
          },{
            name:'吴浩泽 12岁',
            cover:require(`@/assets/dengkao/6.jpg`)
          },{
            name:'谷艾 13岁',
            cover:require(`@/assets/dengkao/7.jpg`)
          },{
            name:'尹子睿 10岁',
            cover:require(`@/assets/dengkao/8.jpg`)
          },
        ],

    };
  },
  computed: {},
  methods: {
      async getNewsTeachingList(){
        //type :通知公告4  考试大纲5  考试教材6  历年试卷7   师资培训8  组考单位9
        let params = {
                clazz:6,
                pageNum:1,
                pageSize:10,
            }
            let resData = await Api.Home.getNewsList(params);
            this.TeachingList = resData.rows;

        },
  },
  mounted() {
      //  this.getNewsTeachingList()

  },
  beforeDestroy() {},
};
</script>

<style lang="less" >
@import "./less/news_common.less";
@basisColor: #1c4b90;
@bgColor: #eef3f6;
@white: #fff;
.exhibition {
  background-color: @white;
  .main {
    width: 1200px;
    margin: 0 auto;
  }
  .service-box {
    .common {
      padding-top: 30px;
      .common-top {
        p:nth-child(1) {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #666666;
        }
        p:nth-child(2) {
          width: 200px;
          background: #ececec;
          height: 1px;
          margin: 20px 0;
          span {
            display: inline-block;
            width: 44px;
            height: 6px;
            background: #cc4c4d;
          }
        }
      }
      .column {
          .column-top {
              padding-top:10px;
              padding-bottom:30px;
              width: 500px;
              margin: 0 auto;
              .summary span {
                flex:2;
                text-align: center;
                font-size: 18px;
                color: #999; 
                line-height: 15px;
                border-left: 1px solid #999;
                &:first-child {
                    border-left:0;
                }
            }
          }
          .column-center {
              width: 600px;
              margin: 0 auto;
              padding-top:20px;
              img {
                width: 21px;
                height: 23px;
                margin-right:10px;
                }
              p {
                font-size: 16px;
                font-family: Microsoft YaHei;
                color: #999999;
              }
          }
          .column-bottom {
              padding-top:30px;
              p {
                  font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                    line-height: 36px;
              }
          }
      }
      .img-list {
          width: 100%;
          padding:20px 0;
          .series-item {
            margin-right:15px;
            width: calc((100% / 4) - 15px);
            padding:10px 0;
            .item-board {
              padding:10px;
            background: #FFFDFE;
            border: 1px solid #E9E9E9;
            border-radius: 5px;
              img {
                width: 251px;
                height: 154px;

              }
              p {
                // width: 174px;
                text-align: center;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                line-height: 24px;
                overflow:hidden; 
              text-overflow:ellipsis;
              display:-webkit-box; 
              -webkit-box-orient:vertical;
              -webkit-line-clamp:2; 
              }
            }
        }
      }
    }
  }
}
</style>
